import { type TranslationFnc } from '~/_shared/utils/hooks';
import { isNullsy } from '~/_shared/utils/typeGuards';
import { EMPTY_GROUP_ID } from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/createCustomBoundaryPane/createBoundaryGroupFromAIModal/useGetColumnATOMetrics';
import {
  LOCATION_COUNT_ID, type ValidateWMSTerritoryConstraintResultItem,
} from './constraints.repository';

export const getConstraintValidationErrorMessages = (vtcri: Omit<ValidateWMSTerritoryConstraintResultItem, 'metric'>, t: TranslationFnc): string[] => {
  const errors = [];

  if (vtcri && !vtcri.isValid) {
    if (vtcri.limits.lowestMax !== null && vtcri.limits.lowestMax > vtcri.value.max) {
      errors.push(t('boundaryAI.Constraints.Error.MaximumLowerThan{{LowestMaximum}}',
        { LowestMaximum: vtcri.limits.lowestMax }));
    }
    if (vtcri.limits.highestMin !== null && vtcri.limits.highestMin < vtcri.value.min) {
      errors.push(t('boundaryAI.Constraints.Error.MinimumHigherThan{{HighestMinimum}}',
        { LowestMaximum: vtcri.limits.lowestMax }));
    }
  }

  return errors;
};

/** Check if a metric id is the location count metric*/
export const isLocationCount = (metricId: string) =>
  metricId === LOCATION_COUNT_ID;

export const normalizeEmptyGroupIdForBackend = (groupId: string): string => {
  return groupId === EMPTY_GROUP_ID ? '' : groupId;
};

export const getConstraintValidationKey = (id: string, groupId?: string | null): string => {
  if (isNullsy(groupId)) {
    return id;
  }
  return `${id}|${groupId}`;
};
